import React from "react"
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap"
import { refusalText } from "./catalogOperations"

// Where a catalog command stands, in the dialog that sent it or above the list: waiting, unconfirmed with Retry, or refused.
// Nothing once it is saved (the Setup tab says „Saved. …” above the list) or before it starts.
export function OperationStatus({ operation, form = false }) {
  if (operation.status === "pending") return <div role="status" className="small text-muted mt-3"><Spinner size="sm" className="mr-1" /> Saving the change…</div>
  if (operation.status === "unknown") return <Alert color="warning" className="mt-3 mb-0">{refusalText(operation.code)}{" "}
    <Button color="link" className="p-0 align-baseline" onClick={operation.retry}>Retry</Button></Alert>
  if (operation.status === "failed") return <Alert color="danger" className="mt-3 mb-0">{refusalText(operation.code, operation.details, { form })}</Alert>
  return null
}

// Confirms an activation or a deactivation (docs/design/tournament-feedback, „Confirmările”). `target` is
// `{ action, kind: 'theme' | 'reason', theme, item, position }`; `featureOn` is the feature's state in this environment.
export function ConfirmDialog({ target, featureOn, operation, onConfirm, onClose }) {
  const { action, kind, theme, item, position } = target
  const name = kind === "theme" ? item.ro.title : item.ro.text
  const activate = action === "activate"
  const verb = activate ? "Activate" : "Deactivate"
  const where = kind === "theme" ? `as theme ${position}` : `in „${theme.ro.title}”, as reason ${position}`
  return <Modal isOpen centered toggle={onClose}>
    <ModalHeader toggle={onClose}>{verb} {kind} „{name}”?</ModalHeader>
    <ModalBody>
      {activate ? <p>Players will see it in the feedback forms opened from now on, {where}.</p> : <>
        <p>Players will no longer see it in the feedback forms opened from now on.</p>
        <p>Answers already given stay in the feedback, its history and analytics, marked as deactivated. A player who modifies their
          feedback keeps those answers unless they change that theme's rating.</p>
        {item.type === "generalNote" && <p>Players with a general note of 1–3 stars will no longer be asked what went wrong with the organizer.</p>}
      </>}
      {!featureOn && <p className="text-muted small mb-0">Tournament feedback is off in this environment, so players see the change only once it is turned on.</p>}
      <OperationStatus operation={operation} />
    </ModalBody>
    <ModalFooter>
      <Button color="light" onClick={onClose}>Cancel</Button>
      <Button color={activate ? "primary" : "danger"} disabled={operation.busy} onClick={onConfirm}>
        {operation.busy ? "Saving…" : `${verb} ${kind}`}</Button>
    </ModalFooter>
  </Modal>
}
